import React from 'react';
import { useTranslation } from 'react-i18next';
import uuid from 'uuid-random';
import PropTypes from 'prop-types';
import { sendCustomTrackingInfo } from '@panel/commons';
import Alert from '@panel/commons/lib/Alert/Alert';
import Premier from '@panel/commons/assets/icons/tag-premier.svg';
import Header from '../PageHeader';
import ImageDefault from '../../assets/img/imageInmobiliariaDefault.svg';
import { Container, CardContainer, Img, TagPremier, PhoneContainer, PhoneStyled } from './styles';

const Preview = ({ device, userInfo, postingData, setUpdateDataModal = () => {} }) => {
  const { t } = useTranslation();
  const { premier } = userInfo;
  const { phone } = postingData;
  const contactName = postingData && postingData.contact_name;
  const responsibleName = postingData && postingData.user_responsible_name;
  const phoneSource = postingData && postingData.phone_source;
  const urlLogo = postingData && postingData.logoUrl;
  const filterTel = phone && phone.filter(number => number.phone_type !== 'WHATSAPP');

  /**
   * La función calcula la cantidad de caracterees de cada teléfono
   * @returns si la cantidad de caracteres es menor a 26 devuelve true, caso contraro será false
   */
  const isRowDirection = () => {
    const lengthTel1 = filterTel && filterTel[0] && filterTel[0].filterTel && filterTel[0].filterTel.length;
    const lengthTel2 = filterTel && filterTel[1] && filterTel[1].filterTel && filterTel[1].filterTel.length;
    const lengthTel3 = (filterTel && filterTel[2] && filterTel[2].filterTel && filterTel[2].filterTel.length) || 0;
    const totalLength = lengthTel1 + lengthTel2 + lengthTel3;
    return totalLength < 26;
  };

  return (
    <Container device={device}>
      <Header
        title={t('panel.contactosPermisos.ContactData.preview.title')}
        subtitle={t('panel.contactosPermisos.ContactData.preview.subtitle')}
        titleSize='20px'
        titleWeight='600'
        dataPanel='preview'
      />
      <CardContainer device={device}>
        <div className='imageContainer'>
          <Img device={device} src={urlLogo || ImageDefault} data-panel='panel-contactosPermisos-publisher-logo'>
            {premier && <TagPremier src={Premier} data-panel='panel-contactosPermisos-publisher-logoPremier' />}
          </Img>
        </div>
        <div className='infoContainer'>
          <div className='name' data-panel='panel-contactosPermisos-publisher-name'>
            {contactName}
          </div>
          <div className='name' data-panel='panel-contactosPermisos-publisher-ResponsibleName'>
            {responsibleName}
          </div>
          <PhoneContainer
            device={device}
            getDirection={isRowDirection() && filterTel.length <= 3}
            data-panel='panel-contactosPermisos-publisher-phones'
          >
            {filterTel &&
              filterTel.map((tel, index) => {
                return (
                  <div key={uuid()} className='tel'>
                    <PhoneStyled data-panel={`panel-contactosPermisos-tel-${tel.phone}`}>{tel.phone}</PhoneStyled>
                    {// Se muestra el separador cuando se tienen dos o tres teléfonos y la cantidad de caracterés es menor a 26 (sólo para desktop)
                    (((filterTel.length === 2 || filterTel.length === 3) && index === 0) ||
                      (filterTel.length === 3 && index === 1)) &&
                      isRowDirection() &&
                      device === 'desktop' && <div className='separator' />}
                  </div>
                );
              })}
          </PhoneContainer>
        </div>
      </CardContainer>
      {phoneSource === 'POSTING' && (
        <Alert
          message={t('panel.contactosPermisos.ContactData.preview.alert.message')}
          dataPabel='preview'
          fontSize='14px'
          margins={device !== 'desktop' ? '8px 0px 0px' : null}
          withoutBorder
        >
          <div className='containerCta'>
            <button
              type='button'
              data-panel='panel-contactosPermisos-publisher-cta'
              onClick={() => {
                setUpdateDataModal(true);
                sendCustomTrackingInfo({
                  event: 'select_content',
                  content_group: 'Panel',
                  content_type: 'Mis avisos',
                  item_id: 'Actualizar datos CRM'
                });
              }}
            >
              {t('panel.contactosPermisos.ContactData.preview.alert.cta')}
            </button>
          </div>
        </Alert>
      )}
    </Container>
  );
};

Preview.propTypes = {
  device: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({ urlLogo: PropTypes.string, premier: PropTypes.bool }).isRequired,
  postingData: PropTypes.shape({
    contact_name: PropTypes.string,
    user_responsible_name: PropTypes.string,
    phone_source: PropTypes.string,
    phone: PropTypes.arrayOf(PropTypes.shape({ phone: PropTypes.string }))
  }).isRequired
};

export default Preview;
